













import { Component, Vue, Watch } from "vue-property-decorator";
import MediaItem from "@/components/MediaItem.vue";
import { FeedImage } from "@/util/types";
import "intersection-observer";
import scrollama from "scrollama";

const AppProps = Vue.extend({
  props: {
    images: {
      type: Array as () => Array<FeedImage>
    }
  }
});

@Component({
  components: {
    MediaItem
  }
})
export default class MediaFeed extends AppProps {
  scroller = scrollama();
  shouldSkipStepExit = false;
  clientWidth = 0;

  created() {
    this.clientWidth = window.innerWidth;
  }

  mounted() {
    // setup the instance, pass callback functions
    this.indexScroller();
    this.scroller
      .onStepEnter((response: any) => {
        // find the image
        const image = this.findImage(
          response.element.dataset.photoId
        ) as FeedImage;
        this.focusChanged(image);
      })
      .onStepExit((response: any) => {
        const image = this.findImage(response.element.dataset.photoId);
        const imageIndex = response.element.dataset.scrollamaIndex;
        this.$emit("scrolled-past-image", image, imageIndex);
      });

    // setup resize event
    window.addEventListener("resize", this.scroller.resize);
  }

  indexScroller() {
    // this.scroller.destroy();
    this.scroller.setup({
      step: ".mediaItem"
      // debug: true
    });
  }

  @Watch("images")
  onImagesChange(images: Array<FeedImage> | [], oldVal: Array<FeedImage>) {
    // When the new array is <= to the old, means the feed has started over
    this.shouldSkipStepExit = false;
    if (images.length <= oldVal.length) {
      this.shouldSkipStepExit = true;
    }

    this.$nextTick(() => {
      this.indexScroller();
    });
  }

  findImage(photoId: string) {
    return this.images.find(image => {
      return image.id === photoId;
    });
  }

  focusChanged(image: FeedImage) {
    this.$emit("focus-changed", image);
  }
}
